import { inject, Injectable } from '@angular/core';
import { setContext } from '@apollo/client/link/context';
import { StorageService } from './storage-service.service';
/**
 * Class service which is used to set,get and clear the headers for specific url request.
 */
@Injectable({
  providedIn: 'root'
})

export class HeaderService {
  storageService = inject(StorageService)
  /**
    * Variable which is used to define the header for url.
    */
  headers: { headers: { [key: string]: string } } = {
    headers: {}
  };
  /**
   * Method used to set headers for GraphQL requests.
   * This method creates a context for setting the Authorization header using the JWT token
   * stored in the localStorage. If no token is found, it returns an empty headers object.
   * @returns {ApolloLink} A context-setting ApolloLink instance with the appropriate headers.
   */
  public getHeaders(): { [key: string]: string } {
    const token = typeof window !== 'undefined' ? this.storageService.getItem('jwt_token') : null;

    // Start from existing headers
    const headers = { ...this.headers.headers };

    // Set Authorization if not already present
    if (!headers['Authorization'] && token) {
      headers['Authorization'] = token;
    }

    return headers;
  }

  /**
   * Method used to set headers.
   * @returns headers
   */
  getHttpHeaders(): { [key: string]: string } {
    const header: { [key: string]: string } = {};
    header['authorization'] = localStorage.getItem('jwt_token') ?? '';
    return header;
  }
  /**
   * Method used to set a header for a specific key in the headers object.
   * @param {string} key - The key for the header.
   * @param {string} value - The value for the header.
   * @returns {object} - The updated headers object.
   */
  public setHeaders(key: string, value: any) {
    try {

      this.headers['headers'] = Object.assign({}, this.headers['headers'], { [key]: value });
      return this.headers['headers'];
    } catch (err) {
      console.log(err);
      return this.headers['headers'];
    }
  }
  /**
  * Method used to remove a header for a specific key in the headers object.
  * @param {string} key - The key for the header.
  * @returns {object} - The updated headers object.
  */
  public removeHeader(key: string) {
    delete this.headers['headers'][key];
    return this.headers['headers'];
  }
}